import { checkIsAvailableForRentInFuture } from './utils'
import useTranslation from 'hooks/useTranslation'
import { useSelector } from 'react-redux'
import { selectConfig } from 'appSlice'
import RentButton from './RentButton'

const MagElement = ({ data, action, openPopup, isDesktop = false, showSizes = false, showWarehouseTypeName = false }) => {
  const config = useSelector(selectConfig)
  const { name, warehouseTypeName, isAvailableForRentNow, attrs, free_now_to_rent_count, count, for_rent, badge, data: details, rentableType } = data || {}
  const { showWarning, forRentDates } = checkIsAvailableForRentInFuture(isAvailableForRentNow, for_rent)
  const length = Number(details?.internalLength || details?.length)
  const height = Number(details?.internalHeight || details?.height)
  const width = Number(details?.internalWidth || details?.width)

  const { t } = useTranslation('mapDetails')

  return (
    <div className={`magElement${(badge && (!isDesktop || showSizes)) ? ' --badge' : ''}${isDesktop ? ' --desktop' : ''}${isAvailableForRentNow || forRentDates.length > 0 ? '' : ' --orderLast'}`}>

      {badge && (!isDesktop || showSizes) && <div className='badge' style={{ borderColor: badge.borderColor, backgroundColor: badge.bgColor, color: badge.textColor }}>{badge.text}</div>}

      <div className='magElement__row'>
        <div className='magElement__row'>
          <div className='magElement__head'>
            {config?.showAvailableQuantity && <div className='amount'>
              <div className='amount__bg'><span className={`${countBadge(free_now_to_rent_count)}`}></span></div>
              <div className='amount__desc'>{t('amount')}: {free_now_to_rent_count}</div>
            </div>}
            <h2>{showSizes ? <>{details.area} m<sup>2</sup></> : showWarehouseTypeName ? warehouseTypeName : name}</h2>
            {badge && (isDesktop && !showSizes) && <div className='badge' style={{ borderColor: badge.borderColor, backgroundColor: badge.bgColor, color: badge.textColor }}>{badge.text}</div>}
            {!isDesktop && config?.showWarehouseDetails && <div
              className='magElement__label'
              onClick={() => openPopup('details')}>
              <span>{t('seeDetails')}</span>
              <i className='icon icon--info' />
            </div>}
          </div>

          {rentableType === 'parking'
            ? <div className='magElement__body --c-2'>
              <div className='attrItem'>
                <i className='icon icon--length' />
                <span>{t('length')}: {details?.length}m</span>
              </div>
              <div className='attrItem'>
                <i className='icon icon--width' />
                <span>{t('width')}: {details?.width}m</span>
              </div>
            </div>
            : !isDesktop ? <>
              {/* <div className='magElement__important'>
            {attrs?.map((item, idx) => {
              return (
                item.isImportant && <div key={idx} className='magElement__important__item'>
                  <i className={`icon icon--${item.key}-bold`} />
                  <span>{item.name}</span>
                </div>
              )
            })}
            <span className='divider'></span>
          </div> */}

              {attrs?.some(item => !item.isImportant) && <div className='magElement__body'>
                {attrs?.map((item, idx) => {
                  return (
                    !item.isImportant && <div key={idx} className='attrItem'>
                      <i className={`icon icon--${item.key}-bold`} />
                      <span>{item.name}</span>
                    </div>
                  )
                })}
              </div>}

              {showSizes && <div className='magElement__body --c-3'>
                {length > 0 && <div className='attrItem'>
                  <i className='icon icon--length' />
                  <span>{t('length-short')}: {Number(length)}m</span>
                </div>}
                {width > 0 && <div className='attrItem'>
                  <i className='icon icon--width' />
                  <span>{t('width-short')}: {Number(width)}m</span>
                </div>}
                {height > 0 && <div className='attrItem'>
                  <i className='icon icon--height' />
                  <span>{t('height-short')}: {Number(height)}m</span>
                </div>}
              </div>}
            </>
              : showSizes
                ? <div className='magElement__desktopBody --c-3'>
                  {length > 0 && <div className='desktopBody__item'>
                    <i className='icon icon--length' />
                    <span>{t('length-short')}: {Number(length)}m</span>
                  </div>}
                  {width > 0 && <div className='desktopBody__item'>
                    <i className='icon icon--width' />
                    <span>{t('width-short')}: {Number(width)}m</span>
                  </div>}
                  {height > 0 && <div className='desktopBody__item'>
                    <i className='icon icon--height' />
                    <span>{t('height-short')}: {Number(height)}m</span>
                  </div>}
                </div>
                : <div className='magElement__desktopBody'>
                  {/* {attrs?.map((item, idx) => {
                return (
                  item.isImportant && <div key={idx} className='desktopBody__item'>
                    <i className={`icon icon--${item.key}-bold`} />
                    <span>{item.name}</span>
                  </div>
                )
              })} */}
                  {attrs?.map((item, idx) => {
                    return (
                      !item.isImportant && <div key={idx} className='desktopBody__item'>
                        <i className={`icon icon--${item.key}-bold`} />
                        <span>{item.name}</span>
                      </div>
                    )
                  })}
                </div>}
        </div>

        {showWarning && !isDesktop && <div className='magElement__warning__wrapper'>
          <div className='magElement__warning'>
            {t('lastItemInReservation')}
          </div>
        </div>}

        <div className='magElement__footer'>
          <div className='magElement__footer__price'>
            <span>{Number(details?.monthlyGrossPrice)} zł</span>
            <span>{t('monthly')}</span>
          </div>
          <RentButton
            short={isDesktop}
            disabled={!count}
            for_rent={for_rent}
            isAvailableForRentNow={isAvailableForRentNow}
            rent={(date) => {
              if (date) action(date)
              else action()
            }}
            openAvailabilityPopup={() => {
              openPopup('availability')
            }}
          />
        </div>
      </div>

      {showWarning && isDesktop && <div className='magElement__warning__wrapper'>
        <div className='magElement__warning'>
          {t('lastItemInReservation')}
        </div>
      </div>}
    </div>
  )
}

export const countBadge = (freeCount) => {
  if (freeCount < 1) {
    return "zero"
  } else if (freeCount >= 1 && freeCount <= 5) {
    return "empty"
  } else if (freeCount > 5 && freeCount <= 20) {
    return "average"
  } else {
    return "full"
  }
}

export default MagElement